import LivingRight from 'assets/LivingRight.png';
import logo from 'assets/logoIcon.png';
import image1 from 'assets/side1.png';
import image2 from 'assets/side2.png';
import PageHeading from 'components/shared/PageHeading';
import { Col, Container, Image, Row } from 'react-bootstrap';
import { IoIosCheckmarkCircleOutline } from "react-icons/io";

const Living = () => {
  return (
    <div className='py-5 ' style={{ backgroundColor: "var(--color3)" }}>
      <Container>
        <PageHeading color="white" text={"Living Wall"} image={logo} />



        <Row className="text-white pt-4 ">
          <Col md={6} xs={12}>
            <p>
              <strong className='pe-1'>Welcome to Living Wall,</strong>
              your innovative partner in space transformation. We channel the power of digital media and audio-visual technology to connect people, enrich public areas, and elevate brand experiences.
            </p>
            <p>
              <strong className='pe-1'>We collaborate with architects,</strong>
              urban developers, and marketing leaders to enhance public realms and deliver high-end digital solutions for both outdoor and indoor private spaces.
            </p>
          </Col>
          <Col md={6} xs={12}>
            <p>Whether your goal is to captivate, engage, or educate, we provide a turn-key solution. Our mission is to perfectly align with your project's purpose and maximize your outcomes.</p>
            <p>Discover how Living Wall transforms spaces with cutting-edge audio-visual solutions and innovative content, enriching environments and creating unforgettable experiences.</p>
          </Col>
        </Row>

        <Row className="py-4 text-white ">
          <Col lg={6} className="mb-4 mb-lg-0">
            <h3 className="pb-md-4 pb-3">
              What sets Living Wall apart in the digital landscape?
            </h3>
            <h5>Our unique turn-key solution combines:</h5>

            <ul className="list-unstyled py-2">
              <li className="fs-6 mb-2 fw-semibold">
                <IoIosCheckmarkCircleOutline size={24} className="mb-1 me-2" color="var(--color4)" />
                Concept & Planning
              </li>
              <li className="fs-6 mb-2 fw-semibold">
                <IoIosCheckmarkCircleOutline size={24} className="mb-1 me-2" color="var(--color4)" />
                Project Coordination
              </li>
              <li className="fs-6 fw-semibold">
                <IoIosCheckmarkCircleOutline size={24} className="mb-1 me-2" color="var(--color4)" />
                Expert Audio-Visual Installation
              </li>
            </ul>

            <div className="pe-md-5 me-md-5 mt-4">
              <h1 className="mb-0">Leading The Way in</h1>
              <h1 className="mb-md-4 mb-2">
                <i>Digital Innovation</i>
              </h1>
              <p style={{ color: "#BBBABA" }}>
                Living Wall boosts the <strong className="text-white">economic value</strong> of projects and places,
                increases visitation, and fosters learning and creativity.
              </p>
              <p style={{ color: "#BBBABA" }}>
                Our mission is to seamlessly blend digital and physical spaces,
                creating engaging hybrid environments that deliver real benefits to your audience.
              </p>

              <div className="d-md-flex gap-4 mt-5">
                <div className="w-100 mb-3 mb-md-0">
                  <Image src={image2} alt="Side" className="img-fluid w-100" />
                </div>
                <div className="w-100">
                  <Image src={image1} alt="Side" className="img-fluid w-100" />
                </div>
              </div>
            </div>
          </Col>

          <Col lg={6}>
            <div className="h-100">
              <Image src={LivingRight} alt="Right Image" className="img-fluid h-100 w-100" />
            </div>
          </Col>
        </Row>


      </Container>
    </div>
  )
}

export default Living